/**
 * Lenz · Animaciones para los 4 iconos del section "text-with-icons"
 *
 * Funcionalidad:
 *   1. Page load → fade-in escalonado de los 4 iconos (clase lenz-twi-loaded).
 *   2. Scroll into viewport → animación one-shot semántica por icono
 *      (clase lenz-twi-played).
 *   3. Hover → manejado 100% por CSS (no requiere JS).
 *
 * Implementación:
 *   - IntersectionObserver con threshold 0.5 para asegurar que el icono
 *     esté visible antes de animarlo.
 *   - `unobserve` después del primer trigger para que sea one-shot.
 *   - Si IntersectionObserver no está disponible (browsers antiguos),
 *     marca todos los items como played al iniciar.
 *   - Respeta prefers-reduced-motion: el CSS anula transforms, este JS
 *     solo agrega clases que el CSS interpreta.
 */
(function () {
  'use strict';

  // Evitar doble inicialización si la section se re-renderea (theme editor)
  if (window.__lenzTwiAnimBoot) return;
  window.__lenzTwiAnimBoot = true;

  function init() {
    var items = document.querySelectorAll('.lenz-twi-item');
    if (!items.length) return;

    // 1. Marcar items como "ready" (CSS los pone opacity:0 + translateY).
    //    Lo hacemos en JS y no en el HTML directo para que, si el JS falla,
    //    los items queden visibles (graceful degradation).
    items.forEach(function (el) {
      el.classList.add('lenz-twi-ready');
    });

    // 2. Forzar reflow y disparar fade-in escalonado en el siguiente frame.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        items.forEach(function (el) {
          el.classList.add('lenz-twi-loaded');
        });
      });
    });

    // 3. IntersectionObserver para la animación semántica al entrar al viewport.
    if (!('IntersectionObserver' in window)) {
      // Fallback: marcar todos como played sin esperar scroll.
      items.forEach(function (el) {
        // Pequeño delay después del fade-in para que se aprecie la animación.
        setTimeout(function () {
          el.classList.add('lenz-twi-played');
        }, 800);
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        // Pequeño delay para que la animación de entrada al viewport
        // ocurra después del fade-in (no compitiendo en el mismo frame).
        setTimeout(function () {
          el.classList.add('lenz-twi-played');
        }, 200);
        observer.unobserve(el);   // one-shot
      });
    }, {
      threshold: 0.5,
      rootMargin: '0px 0px -10% 0px'  // dispara un poco antes de centrarse
    });

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
